import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Sofía M.',
  city: 'Mendoza',
  tier: 'Arranque',
  text: 'Recién matriculada, no sabía ni cómo armar un mail formal. Las plantillas me salvaron la vida en mis primeras semanas.',
  img: 'https://i.pravatar.cc/150?u=sofia'
}, {
  name: 'Ana D.',
  city: 'CABA',
  tier: 'Arranque + Cartera',
  text: 'Ya tenía 2 propiedades pero era un caos. El sistema de etiquetas en WhatsApp y la calculadora me ordenaron el negocio al 100%.',
  img: 'https://i.pravatar.cc/150?u=pablo'
}, {
  name: 'Julieta K.',
  city: 'Neuquén',
  tier: 'Arranque',
  text: 'El módulo de objeciones vale oro. Pude rebatir a un propietario que me pedía bajar la comisión y cerré al 3%.',
  img: 'https://i.pravatar.cc/150?u=julieta'
}, {
  name: 'Marcos T.',
  city: 'Mar del Plata',
  tier: 'Arranque + Cartera',
  text: 'El plan de contenido para IG me trajo mi primera tasación por redes. Antes solo dependía de que me recomienden.',
  img: 'https://i.pravatar.cc/150?u=marcos'
}];
export function MoreTestimonials() {
  return <section className="py-20 bg-brand-lighter px-6 lg:px-8" data-id="element-181">
      <div className="max-w-6xl mx-auto" data-id="element-182">
        <div className="text-center mb-12" data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-navy mb-4" data-id="element-184">
            Corredores que ya dejaron de improvisar
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-185">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-soft border border-brand-light flex flex-col sm:flex-row gap-6" data-id="element-186">
              <img src={t.img} alt={t.name} className="w-16 h-16 rounded-full object-cover shrink-0" data-id="element-187" />
              <div data-id="element-188">
                <div className="flex items-center gap-2 mb-1" data-id="element-189">
                  <h4 className="font-bold text-brand-navy" data-id="element-190">{t.name}</h4>
                  <span className="text-sm text-brand-navy/60" data-id="element-191">• {t.city}</span>
                </div>
                <div className="inline-block px-2 py-1 bg-brand-light text-brand-accent text-xs font-bold rounded mb-3" data-id="element-192">
                  Tier: {t.tier}
                </div>
                <p className="text-brand-navy/80 italic text-sm" data-id="element-193">"{t.text}"</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}